import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/common/hooks/useAuth.ts';
import { useAccount } from '@/app/common/hooks/useAccount.ts';
import LoadingSpinner from '@/app/common/components/LoadingSpinner.tsx';
import type { ReactNode } from 'react';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoggedIn } = useAuth();
  const { loaded, noAccountAvailable } = useAccount();

  if (isLoggedIn === null) return <LoadingSpinner />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (noAccountAvailable) return <Navigate to="/no-account" replace />;
  if (!loaded) return <LoadingSpinner />;

  return <>{children}</>;
}
